import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import aboutGraphic from 'assets/img/illustrations/why-widest-net.png';

const About = () => {
  return (
    <section className="wn-section wn-section-soft" id="about">
      <Container>
        <Row className="align-items-center">
          <Col lg={6} className="mb-5 mb-lg-0">
            <div className="wn-fade-in text-center text-lg-start">
              <div className="wn-section-label">
                <span className="label-dot" />
                Who We Are
              </div>
              <h2 className="wn-section-title mb-4">
                We've{' '}
                <span className="wn-gradient-text">been in your chair.</span>
              </h2>
              <p className="wn-section-subtitle mb-3">
                We're not consultants who read a book about AI. We're operators
                who've spent years inside legacy distribution — co-building and
                running the digital and ecommerce operations that carry these
                businesses into the modern era.
              </p>
              <p className="wn-section-subtitle mb-0">
                We know what it's like to modernize a company built on decades
                of relationships and hard-won experience — where the team is
                wary of change and every dollar of ROI has to be real. As your
                fractional <strong>Chief Automation Officer</strong>, you get a
                principal who's actually done this — not a junior team and a
                templated deck. We embed, we build, and we make sure your people
                can run it long after we're gone.
              </p>
            </div>
          </Col>
          <Col lg={6}>
            <div className="wn-fade-in wn-fade-in-delay-1 text-center">
              <Image
                src={aboutGraphic}
                fluid
                alt="Widest Net Technologies — Fractional Chief Automation Officer"
                className="wn-about-graphic rounded-3"
                style={{
                  boxShadow: 'var(--wn-shadow-lg)',
                  maxHeight: '400px',
                  objectFit: 'contain'
                }}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;
